import underscored from 'underscore.string/underscored';

angular
  .module 'filters'
  .filter 'underscored', ->
    (data) ->
      underscored(data)
